<template>
  <div class="flex flex-col gap-y-2 pb-6 animate-pulse">
    <div class="h-5 bg-slate-200 rounded w-28"></div>

    <div class="flex flex-col gap-3">
      <div v-for="n in 2" :key="n" class="bg-gray-100 p-3 rounded-lg flex justify-between">
        <div class="flex flex-col gap-1.5 w-full">
          <div class="flex gap-2 items-center">
            <div class="h-4 bg-slate-200 rounded w-24"></div>
            <div class="h-3 bg-slate-200 rounded w-32"></div>
          </div>
          <div class="h-3 bg-slate-200 rounded w-3/4 mt-1"></div>
        </div>
        <div class="h-6 w-6 bg-slate-200 rounded-full shrink-0"></div>
      </div>
    </div>

    <div class="flex border rounded px-3 py-3 gap-4 items-center mt-2">
      <div class="h-4 bg-slate-200 rounded flex-grow"></div>
      <div class="h-8 bg-slate-200 rounded w-[200px] shrink-0"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
